"use client";

import { useEffect, useRef } from 'react';
import { sendGAEvent } from '@next/third-parties/google';

export default function AnalyticsTracker() {
  const tracked50 = useRef(false);
  const tracked90 = useRef(false);

  useEffect(() => {
    // 1. Time on page tracking (e.g., triggering an event at 30s and 60s)
    const timer30 = setTimeout(() => {
      sendGAEvent({ event: 'time_on_page', value: '30_seconds' });
    }, 30000);
    
    const timer60 = setTimeout(() => {
      sendGAEvent({ event: 'time_on_page', value: '60_seconds' });
    }, 60000);

    // 2. Custom Scroll Depth (50%, 90%)
    const handleScroll = () => {
      // Calculate scroll progress percentage
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      
      const scrollPercentage = ((scrollTop + windowHeight) / documentHeight) * 100;

      // Track 50% scroll
      if (scrollPercentage >= 50 && !tracked50.current) {
        sendGAEvent({ event: 'custom_scroll', value: '50_percent' });
        tracked50.current = true;
      }
      
      // Track 90% scroll (GA4 tracks 90% automatically by default, but this adds a custom explicit log if preferred)
      if (scrollPercentage >= 90 && !tracked90.current) {
        sendGAEvent({ event: 'custom_scroll', value: '90_percent' });
        tracked90.current = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      clearTimeout(timer30);
      clearTimeout(timer60);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // 3. Custom User Properties (Theme, specialized device info)
  // GA4 automatically collects Browser, OS, Country, City, Resolution. 
  // We can track additional custom preferences here.
  useEffect(() => {
    // Example: tracking whether the user's OS is in dark mode
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    sendGAEvent({ 
      event: 'user_preference', 
      theme_preference: isDarkMode ? 'dark' : 'light',
      custom_device_width: window.innerWidth.toString()
    });
  }, []);

  return null; // This component doesn't render anything visually
}
